/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';

/**
 * 
 * @export
 * @interface GetChallengeChallengeId200Response
 */
export interface GetChallengeChallengeId200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetChallengeChallengeId200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetChallengeChallengeId200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {string}
     * @memberof GetChallengeChallengeId200Response
     */
    result?: string;
}

/**
 * Check if a given object implements the GetChallengeChallengeId200Response interface.
 */
export function instanceOfGetChallengeChallengeId200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetChallengeChallengeId200ResponseFromJSON(json: any): GetChallengeChallengeId200Response {
    return GetChallengeChallengeId200ResponseFromJSONTyped(json, false);
}

export function GetChallengeChallengeId200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChallengeChallengeId200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function GetChallengeChallengeId200ResponseToJSON(value?: GetChallengeChallengeId200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': value.result,
    };
}

